import React, { FC } from 'react'
import GlobalContainer from '../globalContainer'
import { ContentColumnsContainer } from './style'

//* Helpers
import { ComponentColumns } from '../../../models/components/columns'
import { renderRichText } from '../../../utils/richTextHandler.utils'
import { Content } from './subcomponents'

type Props = {
  data: ComponentColumns
  pageType?: string
}

const ContentColumns: FC<Props> = ({ data, pageType = '' }) => {
  if (!data) return null

  const moduleSubtitle = data.subtitle?.json || ''
  const moduleTitle = data.title || ''
  const theme = data.theme || 'Light'
  const bottomPadding = data.bottomPadding || 'Large'
  const topPadding = data.topPadding || 'No'
  const alignment = data.alignment || 'left'
  const orangeDivider = data.orangeDivider || (data.orangeDivider === false ? false : true)
  const useCase = data.useCase || ''

  return (
    <ContentColumnsContainer
      $moduleTheme={theme}
      $bottomPadding={bottomPadding}
      $topPadding={topPadding}
      $textAlignment={alignment}
      $orangeDivider={orangeDivider}
      $pageType={pageType}
      $useCase={useCase}
      data-cy="contentColumns">
      <GlobalContainer className="ContentColumns__Container">
        {moduleTitle && <h4 className="ContentColumns__Upper-Title">{moduleTitle}</h4>}
        {moduleSubtitle && (
          <h5 className="ContentColumns__Upper-Subtitle">{renderRichText(moduleSubtitle)}</h5>
        )}

        <Content data={data} theme={theme} />
      </GlobalContainer>
    </ContentColumnsContainer>
  )
}

export default ContentColumns
